import { useQuery } from 'react-query';

import { QueryEntity } from '../types';
import { User } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { useFetcher } from '@/api/useGetFetchConfig';

const useGetUser = () => {
  const fetcher = useFetcher<User>();
  const getUser = async () => fetcher(`${APIBaseChronos}/api/user`);
  return useQuery([QueryEntity.User], getUser, {
    refetchOnWindowFocus: false,
  });
};

export default useGetUser;
